module.exports = __webpack_public_path__ + "img/icons8-delete-shield.556f6122.svg";